import React from "react";
import {
  Box, Button, Checkbox, Dialog, DialogActions, DialogContent,
  DialogTitle, IconButton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, Typography,
  Paper, InputAdornment
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import "./style.css";

const BPUserDetailsComponent = ({
  BPList,
  selectedRows,
  handleSelectAll,
  handleCheckboxChange,
  editOpen,
  setEditOpen,
  editedName,
  setEditedName,
  handleEditClick,
  handleSaveEdit,
  unlinkOpen,
  setUnlinkOpen,
  handleUnlinkClick,
  handleConfirmUnlink,
  searchValue,
  handleSearchChange,
  handleStatusToggle,
  currentStatusFilter,
  handleAddNewUser,
  handleBulkActivate,
  handleBulkDeactivate,
  handleScroll,
  loading,
  setEditedDepartmentName,
  editedDepartmentName
}) => {
  const navigate = useNavigate();

  return (
    <Box className="bp-user-management-container">
      <Sidebar />
      <Box className="bp-user-management-content">
        <div className="warehouse-assortment-header">
          <button className="warehouse-assortment-back-btn" onClick={() => navigate(-1)}>
            ←
          </button>
          <h2>BP User Details</h2>
        </div>

        <Box className="bp-user-controls-container">
          <Box className="bp-user-filter-section">
            <Box className="bp-user-status-toggle-group">
              <Button
                className={`bp-user-status-toggle ${currentStatusFilter === 'active' ? 'active' : ''}`}
                variant={currentStatusFilter === 'active' ? 'contained' : 'outlined'}
                color="primary"
                onClick={() => handleStatusToggle('active')}
                sx={{
                  fontWeight: currentStatusFilter === 'active' ? 'bold' : 'normal',
                  backgroundColor: currentStatusFilter === 'active' ? '#1976d2' : 'inherit',
                  color: currentStatusFilter === 'active' ? '#fff' : 'inherit',
                  '&:hover': {
                    backgroundColor: currentStatusFilter === 'active' ? '#1565c0' : 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                Active
              </Button>
              <Button
                className={`bp-user-status-toggle ${currentStatusFilter === 'inactive' ? 'inactive' : ''}`}
                variant={currentStatusFilter === 'inactive' ? 'contained' : 'outlined'}
                color="primary"
                onClick={() => handleStatusToggle('inactive')}
                sx={{
                  fontWeight: currentStatusFilter === 'inactive' ? 'bold' : 'normal',
                  backgroundColor: currentStatusFilter === 'inactive' ? '#d32f2f' : 'inherit',
                  color: currentStatusFilter === 'inactive' ? '#fff' : 'inherit',
                  '&:hover': {
                    backgroundColor: currentStatusFilter === 'inactive' ? '#c62828' : 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                Inactive
              </Button>
            </Box>

            <TextField
              className="bp-user-search-input"
              variant="outlined"
              size="small"
              placeholder="Search by Employee ID/Name"
              value={searchValue}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className="bp-user-search-icon">
                    <SearchIcon />
                  </InputAdornment>
                ),
                className: "bp-user-search-input-field"
              }}
            />
          </Box>

          <Box className="bp-user-actions-section">
            <Button
              className="bp-user-add-button"
              variant="contained"
              color="success"
              onClick={handleAddNewUser}
            >
              + Add New User
            </Button>
          </Box>
        </Box>



        <Box className="bp-user-table-wrapper">
          <TableContainer component={Paper} className="bp-user-table-container">
            <Table className="bp-user-data-table">
              <TableHead className="bp-user-table-head">
                <TableRow className="bp-user-table-header-row">
                  <TableCell padding="checkbox">
                    <Checkbox
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      indeterminate={selectedRows.length > 0 && selectedRows.length < BPList.length}
                      checked={BPList.length > 0 && selectedRows.length === BPList.length}
                    />
                  </TableCell>
                  <TableCell>Employee ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>E-Mail</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Box className="bp-user-table-body-scroll" onScroll={handleScroll}>
              <Table className="bp-user-data-table">
                <TableBody>
                  {BPList?.map((row, i) => (
                    <TableRow key={i} hover>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedRows.includes(i)}
                          onChange={() => handleCheckboxChange(i)}
                        />
                      </TableCell>
                      <TableCell>{row.usersCorporateId}</TableCell>
                      <TableCell>{row.userName}</TableCell>
                      <TableCell>{row.emailId}</TableCell>
                      <TableCell>{row.businessName || '-'}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleEditClick(i)} color="primary">
                          <EditIcon />
                        </IconButton>
                        {row.unlinkRequest === true && (
                          <Button
                            onClick={() => handleUnlinkClick(i)}
                            color="error"
                            size="small"
                            variant="outlined"
                          >
                            Unlink
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                  {BPList?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography>No users found.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </TableContainer>
        </Box>
        {selectedRows.length > 0 && (
          <Box className="bp-user-bulk-action-bar">
            {currentStatusFilter === "active" ? (
              <Button
                variant="contained"
                color="error"
                onClick={handleBulkDeactivate}
                disabled={loading}
              >
                {loading
                  ? `Deactivating...`
                  : `Deactivate ${selectedRows.length > 1 ? "Users" : "User"} (${selectedRows.length})`}
              </Button>
            ) : (
              <Button
                variant="contained"
                color="success"
                onClick={handleBulkActivate}
                disabled={loading}
              >
                {loading
                  ? `Activating...`
                  : `Activate ${selectedRows.length > 1 ? "Users" : "User"} (${selectedRows.length})`}
              </Button>
            )}
          </Box>
        )}


        <Dialog open={editOpen} onClose={() => setEditOpen(false)} PaperProps={{
          sx: {
            borderRadius: 3,
            paddingX: 2,
            paddingY: 1,
            minWidth: 360,
          }
        }}>
          <DialogTitle sx={{ fontWeight: 'bold' }}>Edit User Details</DialogTitle>

          <DialogContent>
            <TextField
              fullWidth
              label="Name"
              placeholder="Enter Name"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              margin="dense"
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Department Name"
              placeholder="Enter Department Name"
              value={editedDepartmentName}
              onChange={(e) => setEditedDepartmentName(e.target.value)}
              margin="dense"
              variant="outlined"
            />
          </DialogContent>

          <DialogActions>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                px: 2,
                pb: 2
              }}
            >
              <Button
                onClick={() => setEditOpen(false)}
                variant="outlined"
                color="inherit"
                sx={{ borderRadius: 2, textTransform: 'none', px: 4 }}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                sx={{
                  backgroundColor: '#00A86B',
                  color: 'white',
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 4,
                  '&:hover': {
                    backgroundColor: '#008a58'
                  }
                }}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Submit'}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>


        <Dialog
          open={unlinkOpen}
          onClose={() => setUnlinkOpen(false)}
          PaperProps={{
            sx: {
              borderRadius: 3,
              paddingX: 2,
              paddingY: 1,
              minWidth: 360,
            },
          }}
        >
          <DialogTitle sx={{ fontWeight: 'bold' }}>Confirm Unlink</DialogTitle>

          <DialogContent>
            <Typography sx={{ fontSize: 15, mt: 1 }}>
              Are you sure you want to unlink this user?
            </Typography>
          </DialogContent>

          <DialogActions>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                px: 2,
                pb: 2
              }}
            >
              <Button
                onClick={() => setUnlinkOpen(false)}
                variant="outlined"
                color="inherit"
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 4
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleConfirmUnlink}
                variant="contained"
                color="error"
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 4
                }}
              >
                Unlink
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default BPUserDetailsComponent;